export class DeveloperClient {
    constructor(developerProvider) {
        this.developerProvider = developerProvider;
    }
    async runConsensusNow() {
        if (this.mutableRunConsensusNow === undefined) {
            this.mutableRunConsensusNow = this.runConsensusNowInternal();
        }
        return this.mutableRunConsensusNow;
    }
    async updateSettings(options) {
        await this.developerProvider.updateSettings(options);
    }
    async getSettings() {
        return this.developerProvider.getSettings();
    }
    async fastForwardOffset(seconds) {
        await this.developerProvider.fastForwardOffset(seconds);
        await this.runConsensusNow();
    }
    async fastForwardToTime(seconds) {
        await this.developerProvider.fastForwardToTime(seconds);
        await this.runConsensusNow();
    }
    async reset() {
        await this.developerProvider.reset();
    }
    async getNEOTrackerURL() {
        return this.developerProvider.getNEOTrackerURL();
    }
    async resetProject() {
        await this.developerProvider.resetProject();
    }
    async runConsensusNowInternal() {
        await this.developerProvider.runConsensusNow();
        this.mutableRunConsensusNow = undefined;
    }
}

//# sourceMappingURL=DeveloperClient.js.map
